import React from "react";

const NCC_LOGO = "/ncc-logo.png";

export default function NccBrandedHeader({ subtitle, tagline }) {
  return (
    <div className="relative overflow-hidden rounded-2xl border border-slate-200 bg-gradient-to-b from-[#dbe5fb] via-[#e8eef9] to-white">
      <div className="relative flex flex-col items-center px-5 py-7 text-center">
        <img src={NCC_LOGO} alt="NCC-SWMS · MANPOWER DATABANK" className="w-52 max-w-full" data-testid="brand-header-logo" />
        {subtitle && (
          <h2 className="mt-4 font-heading text-xl font-black uppercase tracking-tight text-slate-900 md:text-2xl">{subtitle}</h2>
        )}
        {tagline && (
          <p className="mt-1 max-w-xl text-sm text-slate-600">{tagline}</p>
        )}
        <div className="mt-4 h-[3px] w-32 bg-gradient-to-r from-[#1e3a8a] via-[#fbbf24] to-[#f59e0b]" />
      </div>
    </div>
  );
}
